<!-- ? V2 1XP -->
<template>
  <div :class="[$style.container, isBranchList && $style.branchList]">
    <div :class="$style.badgeContainer">
      <Badge
        v-if="result.isNew"
        :key="'new'"
        color="blue"
        :text="storeTranslations.translations?.['productfilter.marker.new'] || 'New'"
      />
      <Badge
        v-if="result.isBestSeller"
        :key="'bestseller'"
        color="blue"
        :text="storeTranslations.translations?.['filterapp.bestseller'] || 'Bestseller'"
      />
    </div>
    <div :class="$style.upperContainer">
      <div :class="$style.imageContainer">
        <img :alt="result.alt" :class="$style.image" :src="result.image" />
      </div>
      <div :class="$style.content">
        <div :class="$style.typ">{{ result.type }}</div>
        <a :class="$style.title" :href="resultLink" v-html="result.title" />
        <div v-if="result.text" :class="$style.subline" v-html="result.text" />
      </div>
    </div>

    <div :class="$style.lowerContainer">
      <Divider :class="$style.divider" />
      <div :class="$style.properties">
        <div :class="$style.propertiesLeft">
          <Button
            v-if="result.datasheetLink"
            :class="$style.propertiesLeftButton"
            size="xs"
            start-icon="draft"
            target="blank"
            :text="config.productDatasheet"
            :url="result.datasheetLink"
            variant="linkStatic"
            @click="
              result.wtParams &&
              wtTrack(
                { cat: 'PRODUCTRESULTSHANDLER' },
                {
                  ...result.wtParams,
                  filename: result.datasheetLink,
                },
              )
            "
          />
        </div>
      </div>

      <div :class="$style.buttonsContainer">
        <Button
          v-if="config.secondaryButtonText"
          :class="$style.button"
          size="xs"
          :text="config.secondaryButtonText"
          :url="config.secondaryButtonUrl"
          variant="secondary"
        />
        <Button
          :class="$style.button"
          size="xs"
          :text="config.productDetail"
          :url="resultLink"
          variant="primary"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Badge from '../Badge/Badge.vue';
import Button from '../Button1XP/Button1XP.vue';
import Divider from '../Divider/Divider.vue';
import { useStoreTranslations } from '../../store/translations/translations';

const props = defineProps({
  isBranchList: {
    type: Boolean,
    default: false,
  },
  result: {
    type: Object,
    default: () => {},
  },
  config: {
    type: Object,
    default: () => {},
  },
  additionalUrlParam: {
    type: String,
    default: '',
  },
});

const storeTranslations = useStoreTranslations();

const wtTrack = window.wtTrack;

const resultLink = computed(() => {
  if (props.additionalUrlParam.length === 0) {
    return props.result.link;
  }

  const paramDelimiter = props.result.link.indexOf('?') !== -1 ? '&' : '?';
  return props.result.link + paramDelimiter + props.additionalUrlParam;
});
</script>

<style module lang="scss">
@forward './ProductTeaser.scss';
</style>
